export const TABLE_TYPE = 'table'
export const WALL_TYPE = 'walls'
export const INTERIOR_TYPE = 'interior'


export const TabeleTypes = ['roundTable', 'rectangleTable']
export const InteriorItemTypes = [
	'tree', 'bush', 'plant',
	'doorLeft', 'doorRight', 'doubleDoors',
	'chair', 'barChair', 'sofa',
	'bar', 'column', 'exit',
	'wc']
export const WallTypes = ['horizontalWall', 'verticalWall', 'horizontalWindow', 'verticalWindow']
